import React from 'react';
import { RADIUS, useTheme, type Theme } from '../../theme';

export type BadgeTone = 'accent' | 'ok' | 'neutral' | 'danger' | 'info';

function tone(T: Theme, t: BadgeTone): React.CSSProperties {
  switch (t) {
    case 'accent': return { background: T.accentSoft, color: T.accentText };
    case 'ok': return { background: T.okSoft, color: T.ok };
    case 'danger': return { background: T.dangerSoft, color: T.danger };
    case 'info': return { background: T.infoSoft, color: T.info };
    case 'neutral': return { background: T.surface2, color: T.textSub };
  }
}

/**
 * Statusetikett (24 px hög). Färgen kommer från rollerna, så texten klarar 4,5:1 i båda teman.
 * `dot` visar en prick i textens färg, `color` ger en egen prickfärg (t.ex. gruppfärg).
 */
export function Badge({ tone: t = 'neutral', dot, color, children, style }: {
  tone?: BadgeTone; dot?: boolean; color?: string; children: React.ReactNode; style?: React.CSSProperties;
}) {
  const T = useTheme();
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6, height: 24, padding: '0 10px', borderRadius: RADIUS.pill,
      fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap', verticalAlign: 'middle', ...tone(T, t), ...style,
    }}>
      {(dot || color) && <span aria-hidden style={{ width: 8, height: 8, borderRadius: '50%', background: color ?? 'currentColor', flexShrink: 0 }} />}
      {children}
    </span>
  );
}
